import React from 'react'
import { format } from 'date-fns'
import { routes } from 'routes'
import useVerticalData from 'hooks/useVerticalData'
import * as seoJob from 'containers/job/components/seo/seoJob.lib'
import { Seo } from 'components/seo/Seo'

export const SeoJob = ({ job }: { job: seoJob.JobForSeo }) => {
    const verticalData = useVerticalData()
    const { verticalConfig, vertical, allVerticalUrls } = verticalData
    const verticalUrl = allVerticalUrls[vertical]

    const title = seoJob.title(job)
    const description = seoJob.description(job)
    const keywords = seoJob.keywords(verticalConfig, job)
    const canonicalUrl = seoJob.canonicalUrl(job)
    const noIndexAndNoFollow = seoJob.shouldNoIndexAndNoFollow(vertical, job)

    const currentUrl = verticalUrl + routes.job({ slug: job.slug })

    let jobLocation: object = {
        '@type': 'Place',
        address: seoJob.structuredDataLocation(job),
    }

    if (job.remote) {
        jobLocation = {
            ...jobLocation,
            additionalProperty: {
                '@type': 'PropertyValue',
                value: 'TELECOMMUTE',
            },
        }
    }

    return (
        <Seo
            title={title}
            description={description}
            keywords={keywords}
            openGraph={{
                title: title,
                url: currentUrl,
                description: description,
                images: [{ url: seoJob.image(job) }],
                site_name: verticalConfig.platformName,
            }}
            canonical={canonicalUrl}
            nofollow={noIndexAndNoFollow}
            noindex={noIndexAndNoFollow}
            author={job.company.name}
            twitter={{
                card: 'summary_large_image',
                site: verticalConfig.twitter,
                creator: verticalConfig.twitter,
                pairs: seoJob.twitterData(job),
            }}
            structuredData={{
                '@context': 'http://schema.org',
                '@type': 'JobPosting',
                title,
                name: title,
                industry: 'Technology',
                url: currentUrl,
                hiringOrganization: {
                    '@type': 'Organization',
                    name: job.company.name,
                    logo: seoJob.image(job),
                },
                datePosted: job.lastModified
                    ? format(new Date(job.lastModified), 'y-MM-dd')
                    : undefined,
                employmentType: seoJob.structuredDataEmploymentType(job),
                jobLocation,
                jobLocationType: seoJob.structuredJobLocationType(job),
                description: seoJob.structuredDataDescription(job),
                baseSalary: seoJob.structuredDataRemuneration(job),
                experienceRequirements: seoJob.structuredExperienceRequirements(job),
                applicantLocationRequirements: seoJob.structuredApplicantLocationRequirements(
                    job,
                ),
            }}
        />
    )
}
